import DisclosureAppResource from "./DisclosureAppResource";
import EscrowOfficerAppResource from "./EscrowOfficerAppResource";
import HomeSaleLegalProtectionAppResource from "./HomeSaleLegalProtectionAppResource";
import LuAccountTypeAppResource from "./LuAccountTypeAppResource";
import LuDisclosureFormAppResource from "./LuDisclosureFormAppResource";
import LuHslpCancellationReasonAppResource from "./LuHslpCancellationReasonAppResource";
import LuHslpUpsellPaymentTermAppResource from "./LuHslpUpsellPaymentTermAppResource";
import LuHslpUpsellPurchasedByTypeAppResource from "./LuHslpUpsellPurchasedByTypeAppResource";
import LuOrderedByTypeAppResource from "./LuOrderedByTypeAppResource";
import LuOrderPaymentTermAppResource from "./LuOrderPaymentTermAppResource";
import LuOrderSolutionAppResource from "./LuOrderSolutionAppResource";
import LuOrderStatusAppResource from "./LuOrderStatusAppResource";
import LuStateAppResource from "./LuStateAppResource";
import OrderAppResource from "./OrderAppResource";
import OrderPropertyAppResource from "./OrderPropertyAppResource";
import OrderSellerAppResource from "./OrderSellerAppResource";
import SellerAppResource from "./SellerAppResource";
import UserAppResource from "./UserAppResource";
import BrokerAppResource from "./BrokerAppResource";
import EmailAppResource from "./EmailAppResource";
import LuDisclosureFormPreferenceAppResource from "./LuDisclosureFormPreferenceAppResource";
import LuEmailStatusAppResource from "./LuEmailStatusAppResource";
import TierAppResource from "./TierAppResource";
import InvitationResource from './InvitationAppResource';
import FileAppResource from './FileAppResource';
import FormsetAppResource from './FormsetAppResource';
import FormAppResource from './FormAppResource';
import JotFormAnswerAppResource from "./JotFormAnswerAppResource";
import JotFormDisclosureSessionAppResource from "./JotFormDisclosureSessionAppResource";
import InviteeInfoAppResource from "./InviteeInfoAppResource";
import SignDisclosureAppResource from "./SignDisclosureAppResource";
import ReferringPlatformAppResource from "./ReferringPlatformAppResource";
import ActivityLogAppResource from "./ActivityLogAppResource";
import WildAppResource from "./WildAppResource";
import ProfessionalLicenseAppResource from "./ProfessionalLicenseAppResource";
import ThirdPartyIntegrationsPivotAppResource from "./ThirdPartyIntegrationsPivotAppResource";
import ThirdPartyIntegrationsAppResource from "./ThirdPartyIntegrationsAppResource";
import FormsetStartPageAppResource from "./FormsetStartPageAppResource";
import FormsetSuccessPageAppResource from "./FormsetSuccessPageAppResource";
import WorkspaceTypeAppResource from "./WorkspaceTypeAppResource";
import ContactAppResource from './ContactAppResource';
import LuContactTypeAppResource from './LuContactTypeAppResource';

export default [
    DisclosureAppResource,
    EscrowOfficerAppResource,
    HomeSaleLegalProtectionAppResource,
    LuAccountTypeAppResource,
    LuContactTypeAppResource,
    LuDisclosureFormAppResource,
    LuHslpCancellationReasonAppResource,
    LuHslpUpsellPaymentTermAppResource,
    LuHslpUpsellPurchasedByTypeAppResource,
    LuOrderedByTypeAppResource,
    LuOrderPaymentTermAppResource,
    LuOrderSolutionAppResource,
    LuOrderStatusAppResource,
    LuStateAppResource,
    OrderAppResource,
    OrderPropertyAppResource,
    OrderSellerAppResource,
    SellerAppResource,
    UserAppResource,
    BrokerAppResource,
    EmailAppResource,
    LuDisclosureFormPreferenceAppResource,
    LuEmailStatusAppResource,
    TierAppResource,
    InvitationResource,
    FileAppResource,
    FormsetAppResource,
    FormAppResource,
    JotFormAnswerAppResource,
    JotFormDisclosureSessionAppResource,
    InviteeInfoAppResource,
    SignDisclosureAppResource,
    ReferringPlatformAppResource,
    ActivityLogAppResource,
    WildAppResource,
    ProfessionalLicenseAppResource,
    ThirdPartyIntegrationsPivotAppResource,
    ThirdPartyIntegrationsAppResource,
    FormsetStartPageAppResource,
    FormsetSuccessPageAppResource,
    WorkspaceTypeAppResource,
    ContactAppResource
];
